import React from 'react';
import { Phone, MessageCircle, Clock, Mail } from 'lucide-react';

const ContactSection = () => {
  const whatsappNumber = '50688937777';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  return (
    <section id="contacto" className="py-20 px-6" style={{ background: 'var(--sendhapy-teal)' }}>
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
          ¿Necesitas más información?
        </h2>
        <p className="text-xl text-white/90 mb-12">
          Somos tu conexión entre Miami y Costa Rica. Estamos aquí para ayudarte.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {/* WhatsApp Card */}
          <div className="bg-white rounded-2xl p-8 text-left">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
                 style={{ background: '#25D366' }}>
              <MessageCircle size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--sendhapy-teal)' }}>
              WhatsApp
            </h3>
            <p className="text-gray-600 mb-4">
              La forma más rápida de contactarnos
            </p>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl font-bold hover:underline"
              style={{ color: 'var(--sendhapy-yellow)' }}
            >
              +506 8893-7777
            </a>
            <div className="mt-6">
              <a 
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp w-full"
              >
                <Phone size={18} />
                Abrir WhatsApp
              </a>
            </div>
          </div>

          {/* Horario Card */}
          <div className="bg-white rounded-2xl p-8 text-left">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
                 style={{ background: 'var(--sendhapy-yellow)' }}>
              <Clock size={32} style={{ color: 'var(--sendhapy-teal)' }} />
            </div>
            <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--sendhapy-teal)' }}>
              Horario de Atención
            </h3>
            <div className="space-y-3 text-gray-700">
              <div className="flex justify-between">
                <span className="font-medium">Lunes - Viernes:</span>
                <span>8:00 AM - 5:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Sábado:</span>
                <span className="text-gray-400">Cerrado</span>
              </div>
              <div className="flex justify-between">
                <span className="font-medium">Domingo:</span>
                <span className="text-gray-400">Cerrado</span>
              </div>
              <p className="text-sm text-gray-500 pt-3 border-t border-gray-200">
                * Hora de Costa Rica (GMT-6)
              </p>
            </div>
          </div>
        </div>

        {/* Info adicional */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-4">¿Por qué elegirnos?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            <div>
              <div className="font-semibold mb-2 text-lg" style={{ color: 'var(--sendhapy-yellow)' }}>
                Rápido
              </div>
              <p className="text-sm text-white/80">
                Entregas en 7-10 días desde Miami a tu casa
              </p>
            </div>
            <div>
              <div className="font-semibold mb-2 text-lg" style={{ color: 'var(--sendhapy-yellow)' }}>
                Seguro
              </div>
              <p className="text-sm text-white/80">
                Tus paquetes protegidos en todo momento
              </p>
            </div>
            <div>
              <div className="font-semibold mb-2 text-lg" style={{ color: 'var(--sendhapy-yellow)' }}>
                Confiable
              </div>
              <p className="text-sm text-white/80">
                99.8% de clientes satisfechos
              </p>
            </div>
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-12">
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-sendhapy-primary inline-flex text-lg px-12 py-4"
          >
            <Phone size={20} />
            Contáctanos Ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
